import { render } from "./WScoreRankBody.vue?vue&type=template&id=08073bcb"
import script from "./WScoreRankBody.vue?vue&type=script&lang=js"
export * from "./WScoreRankBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__